import React from 'react';
import { connect } from 'react-redux';
import { RootState } from 'reducers';
import { RouteComponentProps, Link } from 'react-router-dom';
import { Globals, Constants, Colors, Print, checkPermission } from 'utils';
import {
  Table,
  Pagination,
  Tooltip,
  Input,
  DatePicker,
  Select,
  Modal,
} from 'components';
import {
  CleanIcon,
  TrashIcon,
  EditIcon,
  AddIcon,
  Download2Icon,
} from 'assets/icons';
import moment from 'moment';
import { GeneralService, ReportService } from 'services';

declare var window: any;

interface Props extends RootState, RouteComponentProps {
  dispatch: any;
}

const INITIAL_STATE = {
  search: '',
  service_id: '',
  since: '',
  until: '',
};

class AdminReportServicePayments extends React.Component<Props> {
  timer: any = undefined;

  state = {
    header: [
      'Cliente',
      'Cédula',
      'Servicio recibido',
      'ID del servicio',
      'Abogado',
      'Inpre',
      'Fecha del trámite',
      'Monto',
      'N de referencia',
      'Acción',
    ],
    form: INITIAL_STATE,
    data: [],
    page: 1,
    last_page: 1,
    services: [],
  };

  componentDidMount() {
    this.props.dispatch({
      type: 'SET_HEADER',
      payload: {
        title: 'Pagos de servicios',
        onBack: null,
      },
    });

    this.props.dispatch({
      type: 'SET_SUBHEADER',
      payload: {
        title: '',
      },
    });

    this.load();
    this.loadData();
  }

  load = async (withoutLoading: boolean = false) => {
    const res: any = await ReportService.admin.getServicesPayments({
      withoutLoading,
      page: this.state.page,
      ...this.state.form,
      since:
        this.state.form.since &&
        moment(this.state.form.since).format('YYYY-MM-DD'),
      until:
        this.state.form.until &&
        moment(this.state.form.until).format('YYYY-MM-DD'),
    });
    this.setState({
      data: res.payments.rows,
      last_page: res.payments.count,
    });
  };

  loadData = async () => {
    const res: any = await GeneralService.getSelects({
      user_id: this.props.user?.id,
      services: true,
      withoutLoading: true,
    });
    this.setState({
      services:
        res.services?.filter(
          (i: any) =>
            i.id === Constants.SERVICES.CHAT ||
            i.id === Constants.SERVICES.CALL ||
            i.id === Constants.SERVICES.REVISION ||
            i.id === Constants.SERVICES.PREPARATION,
        ) || [],
    });
  };

  reset = () => {
    this.setState(
      {
        form: INITIAL_STATE,
        page: 1,
      },
      () => this.load(true),
    );
  };

  change = (e: any, callback = () => {}) => {
    this.setState(
      {
        page: 1,
        form: {
          ...this.state.form,
          [e.target.name]: e.target.value,
        },
      },
      callback,
    );
  };

  download = async (id: number | null = null) => {
    const res: any = await ReportService.admin.getServicesPayments({
      ...this.state.form,
      id,
      download: true,
      since:
        this.state.form.since &&
        moment(this.state.form.since).format('YYYY-MM-DD'),
      until:
        this.state.form.until &&
        moment(this.state.form.until).format('YYYY-MM-DD'),
    });
    if (window.webkit && window.webkit.messageHandlers) {
      const message = 'open_url';
      const sendToNative = {
        message,
        url: Constants.BASE_STORAGE + res.url,
      };
      const stringifiedMessageObj = JSON.stringify(sendToNative);
      window.webkit.messageHandlers.cordova_iab.postMessage(
        stringifiedMessageObj,
      );
    } else {
      Print(Constants.BASE_STORAGE + res.url);
    }
  };

  render() {
    return (
      <div id="admin-report-payments">
        <div className="row row-filter">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-3">
                <Input
                  value={this.state.form.search}
                  name="search"
                  placeholder="Nombre, CI, inpre"
                  label="Buscar"
                  className="input-table"
                  onSubmit={() => this.load()}
                  onChange={(e: any) => {
                    clearTimeout(this.timer);
                    this.timer = setTimeout(() => {
                      this.load(true);
                    }, 1000);
                    this.change(e);
                  }}
                />
              </div>
              <div className="col-md-2">
                <Select
                  color="white"
                  placeholder="Seleccionar"
                  label="Servicio"
                  name="service_id"
                  onChange={(e: any) =>
                    this.change(e, async () => {
                      this.load(true);
                    })
                  }
                  value={this.state.form.service_id}
                  options={this.state.services.map((item: any) => {
                    return {
                      value: item.id,
                      label: item.name,
                    };
                  })}
                />
              </div>
              <div className="col-md-2">
                <DatePicker
                  label="Desde"
                  placeholder="Desde"
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'since',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.since}
                />
              </div>
              <div className="col-md-2">
                <DatePicker
                  label="Hasta"
                  placeholder="Hasta"
                  onChange={(text: string) => {
                    this.change(
                      {
                        target: {
                          value: text,
                          name: 'until',
                        },
                      },
                      () => this.load(true),
                    );
                  }}
                  value={this.state.form.until}
                />
              </div>
              <div className="col-md-1">
                {this.state.form != INITIAL_STATE && (
                  <button
                    className="btn btn-clean"
                    onClick={() => this.reset()}
                  >
                    <img src={CleanIcon} />
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>

        <Table
          title="Comisiones"
          data={this.state.data.length}
          header={this.state.header}
          titleRight={
            <>
              {this.state.data.length > 0 && (
                <div
                  className="container-download"
                  onClick={() => this.download()}
                >
                  <img src={Download2Icon} />
                  <p>Descargar Excel</p>
                </div>
              )}
            </>
          }
        >
          {this.state.data.map((i: any, index: number) => {
            return (
              <tr key={index}>
                <td>{i?.user?.full_name}</td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {i?.user?.full_document}
                </td>
                <td>{i?.service?.name}</td>
                <td>
                  {i.used_service?.number_format ??
                    i.used_service?.number ??
                    '-'}
                </td>
                <td>
                  {i?.used_service?.lawyer?.full_name ??
                    i?.used_service?.receiver?.full_name ??
                    '-'}
                </td>
                <td>
                  {i?.used_service?.lawyer?.format_lawyer_document ??
                    i?.used_service?.receiver?.format_lawyer_document ??
                    '-'}
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {moment(i?.created_at).format('DD-MM-YYYY')}
                </td>
                <td style={{ whiteSpace: 'nowrap' }}>
                  {Globals.formatMiles(i.total)}
                </td>
                <td>{i?.reference}</td>
                <td>
                  <Tooltip title="Descargar">
                    <img
                      src={Download2Icon}
                      className="download-icon"
                      onClick={() => this.download(i?.id)}
                    />
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </Table>

        <Pagination
          pages={this.state.last_page}
          active={this.state.page}
          onChange={async (page: number) => {
            await this.setState({
              page: page,
            });
            this.load();
          }}
        />
      </div>
    );
  }
}

export default connect((state: RootState) => {
  return {
    user: state.user,
  };
})(AdminReportServicePayments);
